import { useState, useEffect } from 'react';
import FacebookIcon from './FacebookIcon';
import InstagramIcon from './InstagramIcon';
import LinkedInIcon from './LinkedInIcon';
import LocationIcon from './LocationIcon';
import PhoneIcon from './PhoneIcon';
import TwitterIcon from './TwitterIcon';
import YouTubeIcon from './YouTubeIcon';
import GuestSignInLogo from '../GuestSignInLogo';
import { NavLink, useNavigate } from 'react-router-dom';
import Modal from '../../Modal';
import ViewProfile from '../../pages/ViewProfile/ViewProfile';
import { useToken } from '../../auth/useToken';
import useUserDataStore from '../../../store/userDataStore';
import { useLogout } from '../../auth/useLogout';
import { useRole } from '../../../hooks/useRole';

export default function HeaderSubMenu({ profileImage }) {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const logout = useLogout();
  const { role } = useRole();
  const { firstname, lastname, email, phoneNumber, image, district, town } =
    useUserDataStore((state) => state.userData);

  const [openModal, setOpenModal] = useState(false);
  const [token] = useToken();

  const logOut = async () => {
    await logout();
  };

  const toggleModal = (e) => {
    e.preventDefault();
    setOpenModal(!openModal);
  };

  return (
    <div className='header-sub-menu'>
      <Modal open={openModal} toggleModal={toggleModal}>
        <ViewProfile
          userName={`${firstname} ${lastname}`}
          sellerEmail={email}
          phoneNumber={phoneNumber}
          image={image}
          location={`${district}, ${town}`}
          toggleModal={toggleModal}
        />
      </Modal>
      <div className='sub-menu profile-sub-menu'>
        <div
          className='pic-wrap navLink-header-icon pic-wrap-link'
          onClick={toggleModal}>
          <div className='pic-wrapper'>
            {profileImage ? (
              <img
                className='user-profile-pic'
                src={profileImage}
                alt='User profile pic'
              />
            ) : (
              <div className='guest-icon-wrapper'>
                <GuestSignInLogo fillColor={'var(--blue-text-bold)'} />
              </div>
            )}
          </div>
          <p>View Profile</p>
        </div>
        <div className='sub-menu-content'>
          <h6 className='user-name'>{`${firstname} ${lastname}`}</h6>
          {role && role.toLowerCase() !== 'user' && (
            <span className='user-role-tag'>
              {role?.charAt(0).toUpperCase() + role?.slice(1).toLowerCase()}
            </span>
          )}
          <span className='selectable-text-log-out' onClick={() => logOut()}>
            Log Out
          </span>
        </div>
      </div>
      <div className='sub-menu about-sub-menu'>
        <div>
          <NavLink
            to='/swapandtop/tou'
            className='selectable-text sub-menu-links'>
            View terms of use
          </NavLink>
          <NavLink
            to='/swapandtop/privacypolicy'
            className='selectable-text sub-menu-links'>
            View privacy policy
          </NavLink>
          <NavLink
            to='/swapandtop/tipsandrecomandations'
            className='selectable-text sub-menu-links'>
            View tips & recomendations
          </NavLink>
        </div>
      </div>

      <div className='sub-menu contact-us-submenu'>
        <div className='contact-details-wrap'>
          <div className='contact-details'>
            <PhoneIcon svgClass={'header-icon contact-details-icons'} />
            <div>
              <p>+263774 689 010</p>
              <p>+263784 224 614</p>
              <p>+263719 217 717</p>
            </div>
          </div>
          <div className='contact-details'>
            <LocationIcon svgClass={'header-icon contact-details-icons'} />
            <div>
              <p>4442 Ceres Ave</p>
              <p>Waterfalls</p>
              <p>Harare</p>
            </div>
          </div>
        </div>
      </div>
      <div className='sub-menu socials-sub-menu'>
        <div className='feedback-sub-menu'>
          <p>Your feedback is very iportant to us.</p>
          <p>Please e-mail us at</p>
          <a className='selectable-text'>feedback@swapandtop.co.zw</a>
        </div>
        <div className='socials-sub-menu-icons-wrap'>
          <p>Check us out on social</p>
          <div className='socials-icons-wrap'>
            <a href='https://www.facebook.com' target='_blank'>
              <FacebookIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.twitter.com' target='_blank'>
              <TwitterIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.youtube.com' target='_blank'>
              <YouTubeIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.instagram.com' target='_blank'>
              <InstagramIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.linkedin.com' target='_blank'>
              <LinkedInIcon socialIconClass={'social-icon'} />
            </a>
          </div>
        </div>
        <div className='sub-menu-company-name'>
          <a className='selectable-text'>© {currentYear} | Greta Works Inc.</a>
        </div>
      </div>
    </div>
  );
}
